module.exports = __webpack_public_path__ + "img/leftcalf-ecto-mesomorph-female.a18f6646.svg";